export default "__VITE_ASSET__CkxR9FCv__"